import * as moment from 'moment';

import { BaseEntity, MemoizeGetters, Transform, toDate } from './base';

@MemoizeGetters
export class NoteModel extends BaseEntity {
  static readonly UrlRegex = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/;
  message?: string;
  lat?: number;
  lng?: number;

  @Transform(toDate)
  createdAt?: Date;

  get relativeTime() {
    let momentDate = moment(this.createdAt);
    return momentDate.fromNow();
  }

  get url(): string | null {
    const matches = this.message.match(NoteModel.UrlRegex);
    return matches ? matches[0] : null;
  }

  get formattedMessage() {
    if (this.url) {
      const newUrl = `<span class='url'>${this.url}</span>`;
      return this.message.replace(this.url, newUrl);
    }
    return this.message;
  }
}

export interface NoteCreateParams {
  notated_object?: 'User';
  message?: string;
  uid?: string;
  lat?: number;
  lng?: number;
}



// WEBPACK FOOTER //
// ./src/models/note.ts